import { Link } from 'react-router-dom';
import AdminLayout from '../../components/admin/AdminLayout';

export default function AdminDashboard() {
  const adminActions = [
    {
      title: 'Gestione Pizze',
      description: 'Aggiungi, modifica o elimina le pizze dal catalogo',
      path: '/admin/pizze',
      icon: '🍕'
    },
    {
      title: 'Gestione Pizzerie',
      description: 'Gestisci le pizzerie partner',
      path: '/admin/pizzerie',
      icon: '🏪'
    },
    {
      title: 'Gestione Tema',
      description: 'Personalizza font, colori e layout del sito',
      path: '/admin/tema',
      icon: '🎨'
    },
    {
      title: 'Database',
      description: 'Inizializza o resetta il database',
      path: '/test',
      icon: '🗄️'
    }
  ];

  return (
    <AdminLayout title="Dashboard Amministrazione">
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {adminActions.map((action) => (
          <Link
            key={action.path}
            to={action.path}
            className="bg-white rounded-lg shadow-md p-6 hover:shadow-lg transition-shadow"
          >
            <div className="text-4xl mb-4">{action.icon}</div>
            <h3 className="text-xl font-semibold mb-2">{action.title}</h3>
            <p className="text-gray-600">{action.description}</p>
          </Link>
        ))}
      </div>
    </AdminLayout>
  );
}